import {Collapse, Tree, Checkbox, CheckboxProps} from "antd";
import {DataNode, EventDataNode} from "antd/es/tree";
import {Key, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useAppDispatch, useAppSelector} from "../../app/store";
import {setFilterField} from "../../app/store/reducers/appSlice";
import {deunify, unify} from "../../app/utils/strings";
import {FilterContainer, TreeContainer, FilterBlock} from "./styles";
import {localeFilter} from "./const";
import {localeColumns} from "../grid/const";
import i18n from "../../i18n";

enum Fields {
    Activity = 'activity',
    Country = 'country',
    ShipTech = 'st',
}

const ACTIVITY_KEY_SUFFIX = "-parent"

export default function Filter() {
    const dispatch = useAppDispatch()
    const {t} = useTranslation()
    const {activities, countries} = useAppSelector(store => store.AppSlice)
    // const lang = i18n.language as "ru" | "en"
    const lang = i18n.language as "ru" | "en"

    const collapseKeys = window.innerWidth > 768 ? ["countries", "activities"] : []


    const countryTreeData = useMemo((): DataNode[] => {
        const orderKey = lang === 'en' ? 'orderEn' : 'orderRu'
        return countries.slice().sort((a, b) => a[orderKey] - b[orderKey]).map(country => ({
            key: country.value,
            title: country[localeFilter.title[lang]]
        }))
    }, [countries])

    const activitiesTreeData = useMemo((): DataNode[] => activities.map(activity => ({
        key: unify(activity.value, ACTIVITY_KEY_SUFFIX),
        title: activity[localeFilter.title[lang]],
        children: activity.options.map(item => ({key: item.value, title: item[localeFilter.title[lang]]}))
    })), [activities])

    const onCountrySelect = (keys: Key[]) => {
        const value = keys.length ? keys[0] : ""

        dispatch(setFilterField({name: Fields.Country, value}))
    }

    const onActivitySelect = (keys: Key[], evt: { node: EventDataNode<DataNode> }) => {
        const isParentNode = !!evt.node.children
        let value: Key[];

        if (!keys.length) {
            value = []
        } else if (isParentNode) {
            const activity = activities.find(item => item.value.toString() === deunify(evt.node.key.toString(), ACTIVITY_KEY_SUFFIX))
            value = activity?.options.map(item => item.value) || []
        } else {
            value = [evt.node.key]
        }

        dispatch(setFilterField({name: Fields.Activity, value}))
    }

    const onChangeCheckBox: CheckboxProps['onChange'] = (e) => {
        console.log(`checked = ${e.target.checked}`);
        dispatch(setFilterField({name: Fields.ShipTech, value: e.target.checked}))
    };

    return (
        <FilterContainer>
            <Collapse defaultActiveKey={collapseKeys}>
                <Collapse.Panel key="activities" header={t("Activities")}>
                    <TreeContainer>
                        <Tree
                            className="activities-tree"
                            treeData={activitiesTreeData}
                            onSelect={onActivitySelect}
                        />
                    </TreeContainer>
                </Collapse.Panel>
                <Collapse.Panel key="countries" header={t("Country")}>
                    <TreeContainer>
                        <Tree
                            className="countries-tree"
                            treeData={countryTreeData}
                            onSelect={onCountrySelect}
                        />
                    </TreeContainer>
                </Collapse.Panel>
            </Collapse>
            <br></br>
            <FilterBlock>
                <Checkbox onChange={onChangeCheckBox}>SHIP TECH</Checkbox>
            </FilterBlock>


        </FilterContainer>
    )
}
